import * as bootstrap from "bootstrap";
import General from "./components/_general";
import Menu from "./components/_menu";
import Form from "./components/_form";
// import Animate from "./components/_animate";

const App = {
  /**
   * App.init
   */
  init() {
    // General scripts
    function initGeneral() {
      return new General();
    }
    initGeneral();

    // Menu scripts
    function initMenu() {
      return new Menu();
    }
    initMenu();

    // Animate scripts
    // function initAnimate() {
    //   return new Animate();
    // }
    // initAnimate();

    // Form scripts
    function initForm() {
      return new Form();
    }
    initForm();
  },
};

document.addEventListener("DOMContentLoaded", () => {
  App.init();
});
